import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"

import "./company.vue?vue&type=style&index=0&id=7eee1f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eee1f4c"]])

export default __exports__